import { getLoginModeData } from '../api/portalApi/loginMode';
import { ROUTE_BASE_NAME } from '../config';

export function redirectToSsoLogin(params: {
  email?: string;
  redirect_uri?: string;
}) {
  params.redirect_uri = params.redirect_uri ?? ROUTE_BASE_NAME;
  const targetUrl = new URL('/auth/login-sso', globalThis.location.origin);
  targetUrl.search = new URLSearchParams(params).toString();

  globalThis.location.assign(targetUrl.toString());
}

export function redirectToSsoResetPwUrl(email: string) {
  const resetPasswordUrl = getLoginModeData()?.resetPasswordUrl;
  if (resetPasswordUrl) {
    globalThis.location.assign(resetPasswordUrl);
  } else {
    // fallback redirect to /auth/login-sso?email=<email> proxy
    redirectToSsoLogin({ email });
  }
  return;
}
